module.exports = __webpack_public_path__ + "static/media/12 Step based.0343a07e.svg";